import { sdk } from 'utils/query';
import { EmptyParametersError } from 'services/errors/EmptyParametersError';
import { RecoveryCodesMethod } from '@extrahorizon/javascript-sdk';
import { MfaType } from 'models/general';
import { useCustomMutation } from '../../useCustomMutation';

interface RegenerateCodesProps {
  userId?: string;
  password: string;
  callback: (result: RecoveryCodesMethod) => void;
}

export const regenerateRecoveryCodes = async ({ userId, password }: RegenerateCodesProps) => {
  if (!userId) throw new EmptyParametersError();
  const { token: presenceToken } = await sdk.auth.confirmPresence({ password });
  const { methods } = await sdk.auth.users.getMfaSetting(userId);

  const recoveryCodesMethods = methods.filter((method) => method.type === MfaType.RecoveryCodes);
  for (const method of recoveryCodesMethods) {
    await sdk.auth.users.removeMfaMethod(userId, method.id, { presenceToken });
  }

  return await sdk.auth.users.addMfaMethod(userId, {
    presenceToken,
    type: MfaType.RecoveryCodes,
    name: MfaType.RecoveryCodes,
    tags: [],
  });
};

export const useRegenerateCodes = () => {
  return useCustomMutation({
    fn: regenerateRecoveryCodes,
    onSuccess: {
      callback: async (data, variables) => {
        variables.callback(data);
      },
    },
  });
};
